function popup(state={isPopupOpen: false, openDialog: false}, action)
{
switch (action.type) {
    case "SET_POPUP_STATUS":
        return{
            ...state,
            openPopup: action.data
        };
        case "SET_DIALOG":
            return {
                ...state,
                openDialog: action.data
            }
    default:
        return state;
}
}
export default popup;